import { all, call, put, takeEvery } from 'redux-saga/effects'
import { getLoyalty, updateLoyalty } from 'services/loyalty'
import actions from './actions'

export function* GET_LOYALTY() {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true
    }
  })

  const { response } = yield call(getLoyalty)
  const { loyalty } = response.data
  yield put({
    type: actions.SET_STATE,
    payload: {
      data: loyalty,
    },
  })

  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: false
    }
  })
}

export function* UPDATE_LOYALTY({ payload }) {
  console.log('payload1', payload)
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true
    }
  })
  const { updatedData } = payload
  const { response } = yield call(updateLoyalty, updatedData)
  const { loyalty } = response.data
  yield put({
    type: actions.SET_STATE,
    payload: {
      data: loyalty,
      loading: false,
    },
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.GET_LOYALTY, GET_LOYALTY),
    takeEvery(actions.UPDATE_LOYALTY, UPDATE_LOYALTY)
  ])
}